// frontend/src/components/landing/sections/CitationStrip.js
import React from 'react';
import { Box, Typography } from '@mui/material';
import { Container, Reveal } from '../parts';
import { tokens } from '../landingTheme';

// Stands in for a logo strip: the published coding scheme ADAS is built on
const CitationStrip = () => (
    <Box
        component="section"
        aria-label="Coding scheme"
        sx={{ borderTop: `1px solid ${tokens.line}`, borderBottom: `1px solid ${tokens.line}`, py: { xs: 4, md: 5 } }}
    >
        <Container>
            <Reveal
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    alignItems: { md: 'baseline' },
                    gap: { xs: 1, md: 6 },
                }}
            >
                <Typography variant="overline" component="p" sx={{ color: tokens.inkMuted, flexShrink: 0 }}>
                    Built on a published coding scheme
                </Typography>
                <Typography
                    component="p"
                    sx={{ fontFamily: tokens.display, fontWeight: 600, fontSize: { xs: '1.0625rem', md: '1.25rem' }, lineHeight: 1.4, letterSpacing: '-0.01em' }}
                >
                    The Classroom Discourse Analysis Tool (CDAT) · Lee &amp; Irving, 2018, International Journal of STEM Education
                </Typography>
            </Reveal>
        </Container>
    </Box>
);

export default CitationStrip;
